import React from "react";
import wyzedLogo from "assets/integrations/wyzed-logo.png";

const WyzedBrandIcon = ({
  className = "h-4 w-4",
  title = "Wyzed",
  alt = "Wyzed",
}) => (
  <img
    src={wyzedLogo}
    alt={alt}
    title={title}
    className={`object-contain ${className}`}
    loading="lazy"
    decoding="async"
  />
);

export default WyzedBrandIcon;
